import { render } from "./ExitButton-home.vue?vue&type=template&id=3c1a3ae6&scoped=true"
import script from "./ExitButton-home.vue?vue&type=script&lang=js"
export * from "./ExitButton-home.vue?vue&type=script&lang=js"

import "./ExitButton-home.vue?vue&type=style&index=0&id=3c1a3ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1a3ae6"]])

export default __exports__